import DialogActions from '@mui/material/DialogActions';

// ----------------------------------------------------------------------

/**
 * نوار استاندارد عملیات مودال‌های سامانه.
 *
 * اکشن اصلی باید اولین فرزند باشد تا در رابط راست‌به‌چپ در سمت راست قرار بگیرد.
 * در نمایشگرهای کوچک، اکشن‌ها به‌صورت عمودی و تمام‌عرض نمایش داده می‌شوند.
 */
export function AppDialogActions({ children, sx, ...other }) {
  const customStyles = Array.isArray(sx) ? sx : [sx];

  return (
    <DialogActions
      {...other}
      sx={[
        {
          gap: 1,
          flexShrink: 0,
          borderTop: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          justifyContent: 'flex-start',
          alignItems: { xs: 'stretch', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          px: { xs: 2, sm: 3 },
          pt: { xs: 1.5, sm: 2 },
          // Mobile safe-area spacing is provided once by the shared Dialog Paper.
          pb: { xs: 1.5, sm: 2 },
          '& > :not(:first-of-type)': { margin: '0 !important' },
          '& > .MuiButtonBase-root': {
            minHeight: 44,
            width: { xs: '100%', sm: 'auto' },
            minWidth: { sm: 112 },
          },
        },
        ...customStyles.filter(Boolean),
      ]}
    >
      {children}
    </DialogActions>
  );
}
